import HeroSection from "@/components/sections/HeroSection";
import AboutSection from "@/components/sections/AboutSection";
import OverviewSection from "@/components/sections/OverviewSection";
import ServicesSection from "@/components/sections/ServicesSection";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import ProcessSection from "@/components/sections/ProcessSection";
import PricingSection from "@/components/sections/PricingSection";
import IndustriesSection from "@/components/sections/IndustriesSection";
import BenefitsSection from "@/components/sections/BenefitsSection";
import TrustSignals from "@/components/sections/TrustSignals";
import FAQSection from "@/components/sections/FAQSection";
import CTASection from "@/components/sections/CTASection";
import ContactSection from "@/components/sections/ContactSection";
import { useEffect } from "react";

export default function HomePage({ onOpenForm }) {
  useEffect(() => {
    document.title = "Trademark Officers | Expert USPTO Trademark Registration Services";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Trademark Officers provides expert USPTO trademark registration, filing, search, and brand protection services. Protect your brand with our experienced trademark attorneys. Get started from $45."
      );
    }
  }, []);

  return (
    <div data-testid="home-page">
      <HeroSection onOpenForm={onOpenForm} />
      <AboutSection />
      <OverviewSection />
      <ServicesSection onOpenForm={onOpenForm} />
      <WhyChooseUs />
      <ProcessSection />
      <PricingSection onOpenForm={onOpenForm} />
      <IndustriesSection />
      <BenefitsSection />
      <TrustSignals />
      <FAQSection />
      <CTASection onOpenForm={onOpenForm} />
      <ContactSection onOpenForm={onOpenForm} />
    </div>
  );
}
